var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"role":"presentation","aria-labelledby":_vm.iconName,"viewBox":"0 0 24 24"}},[_c('g',[_c('path',{attrs:{"fill":_vm.iconColor,"d":"M18,4H6a1,1,0,0,0-1,.89V20l3-2,2,2,2-2,2,2,2-2,3,2V5a1,1,0,0,0-.89-1Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }